import { getImageProps, ImageProps } from "next/image";

import { HeroV2Props } from "@jti/ui/components/HeroV2";
import { breakpoints } from "@jti/ui/hooks/useCurrentBreakpoint";

export function ResponsiveBackgroundImage({
  desktopImage,
  mediumImage,
  smallImage,
  index,
}: Props) {
  const common: Partial<ImageProps> = {
    fill: true,
    sizes: "100vw",
    priority: index === 0,
    style: { objectFit: "cover" },
  };

  const {
    props: { srcSet: desktop },
  } = getImageProps({
    ...common,
    src: desktopImage?.src || "",
    alt: desktopImage?.alt || "",
  });
  const {
    props: { srcSet: medium },
  } = getImageProps({
    ...common,
    src: mediumImage?.src || "",
    alt: mediumImage?.alt || "",
  });
  const {
    props: { srcSet: small, ...rest },
  } = getImageProps({
    ...common,
    src: smallImage?.src || "",
    alt: smallImage?.alt || "",
  });

  return (
    <picture>
      <source media={breakpoints.lg} srcSet={desktop} />
      <source media={breakpoints.md} srcSet={medium} />
      <source media={breakpoints.sm} srcSet={small} />
      {/* Alt prop is already provided by rest props */}
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <img {...rest} />
    </picture>
  );
}

type Props = Parameters<
  NonNullable<ArrayElement<HeroV2Props["data"]>["renderBackgroundImage"]>
>[0] & { index: number };
